import React from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import PropTypes from 'prop-types'

import ConfigurationCompleteImage from './images/slate_and_scoir.png'
import EnableAudienceSharingImage from './images/slate_linked_scoir.png'
import ActivateMessagingImage from './images/step1.png'
import EnableAudienceInsightsImage from './images/step3.png'

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    borderRadius: 16,
  },
  background: {
    background: 'linear-gradient(180deg, #ACE6E0 -7.36%, #8AD4F2 108.9%)',
  },
  scaled: {
    width: '100%',
    height: 'auto',
    transform: 'scale(0.85)',
  },
}))

const getImage = (config) => {
  const messagingActivated = config && config.messagingActivated
  const matchingActivated = config && config.matchingActivated
  const matchResultsActivated = config && config.matchResultsActivated
  if (!messagingActivated) {
    return ActivateMessagingImage
  }
  if (messagingActivated && !matchingActivated) {
    return EnableAudienceSharingImage
  }
  if (messagingActivated && matchingActivated && !matchResultsActivated) {
    return EnableAudienceInsightsImage
  }
  return ConfigurationCompleteImage
}

const Banner = ({ config }) => {
  const styles = useStyles()
  return (
    <Box
      className={cn([styles.container, styles.background])}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <img
        alt="Slate Activation Example"
        src={getImage(config)}
        className={styles.scaled}
        aria-details="a form with three inputs: Service Account, Authorization Type, and URL."
      />
    </Box>
  )
}

Banner.propTypes = {
  config: PropTypes.object,
}

export default Banner
